import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-content-auth-success',
  templateUrl: './content-auth-success.component.html',
  styleUrls: ['./content-auth-success.component.scss']
})
export class ContentAuthSuccessComponent implements OnInit {
  adminData:any;
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  content_capsule_id :any;data={};contentDetailsData:any;
  constructor(
    private contentAuthoringApi:ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.content_capsule_id = queryParams['id'];
      this.getContentAuthDetails(this.content_capsule_id);
      });
  }
  
  getContentAuthDetails(content_capsule_id:any){
    this.spinner.show();
  this.contentAuthoringApi.getContentAuthDetails(content_capsule_id).subscribe(
    (data)=>{
    if(data.success){
      this.spinner.hide();
      this.contentDetailsData=data.data; 
    }else{
      this.spinner.hide();
      this.errorInfo.isError = true;
      this.errorInfo.errorMsg = 'No data Exist'
    }
    },
    (error) => {
      this.spinner.hide();
      this.errorInfo.errorMsg = error;
     },
  );
}
getMediaType(mediatypeArr:any,media_type:any){
  const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
  return mediatypeArr.some(checkMediType);
  
}
  logout(){
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
   } 

}
